module.exports = __webpack_public_path__ + "img/me.2d0c8f78.svg";